import { render, staticRenderFns } from "./BatteryList.vue?vue&type=template&id=b25dbaea&scoped=true"
import script from "./BatteryList.vue?vue&type=script&lang=ts"
export * from "./BatteryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25dbaea",
  null
  
)

export default component.exports